import classToggle from "../functions/classToggle";

export default class MenuToggle {
    constructor(elem) {
        elem.addEventListener('click', (e) => {
            e.preventDefault();
            classToggle(elem.closest('nav'),'open');
            classToggle(elem.querySelector('.link'), 'clicked');
        });
    }

}